/**
 * Plan Card Skeleton Loader Component
 * Displays skeleton loader while plan cards are loading
 * Requirements: 15.1, 15.2
 */

import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-plan-card-skeleton',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatDividerModule
  ],
  templateUrl: './plan-card-skeleton.component.html',
  styleUrls: ['./plan-card-skeleton.component.scss']
})
export class PlanCardSkeletonComponent {}
